<template>
  <a-modal
    :title="supplierName+'的详细报价'"
    width="90%"
    :dialog-style="{ top: '10px' }"
    :visible="visible"
    @cancel="$emit('cancel')"
    :footer="null"
    :destroyOnClose="true"
    :confirmLoading="modalLoading"
  >
    <a-table
      style="width: 100%"
      class="table"
      bordered
      :dataSource="resultData"
      :rowKey="(record) => record.id"
      :pagination="false"
    >
      <a-table-column key="indexNum" width="5%" title="序号" align="center">
        <template slot-scope="text, record, index">
          {{ record.xuhao ? record.xuhao : index + 1 }}
        </template>
      </a-table-column>
      <a-table-column
        key="subjectName"
        width="12%"
        :title="
          tenderType == '1' ? '货物名称' : tenderType == '2' ? '工程子项' : '服务子项'
        "
        data-index="subjectName"
      >
        <template slot-scope="text, record">
          {{ record.subjectName }}
        </template>
      </a-table-column>
      <a-table-column
        v-if="tenderType === '1'"
        key="specifications"
        width="15%"
        title="品牌及规格型号"
        data-index="specifications"
      >
        <template slot-scope="text, record">
          {{ record.specifications }}
        </template>
      </a-table-column>
      <a-table-column
        v-if="tenderType === '1'"
        key="jscs"
        width="20%"
        title="技术参数"
        data-index="jscs"
      >
        <template slot-scope="text, record">
          {{ record.jscs }}
        </template>
      </a-table-column>
      <a-table-column
        v-if="tenderType !== '1'"
        key="serviceScope"
        width="25%"
        :title="tenderType === '2' ? '施工范围' : '服务内容'"
        data-index="serviceScope"
      >
        <template slot-scope="text, record">
          {{ record.serviceScope }}
        </template>
      </a-table-column>
      <a-table-column
        v-if="tenderType !== '1'"
        key="servicePeriod"
        width="8%"
        align="center"
        :title="tenderType === '2' ? '施工期限' : '服务期限'"
        data-index="servicePeriod"
      >
        <template slot-scope="text, record">
          {{ record.servicePeriod }}
        </template>
      </a-table-column>
      <a-table-column key="ask" width="15%" title="其他说明" data-index="ask">
        <template slot-scope="text, record">
          {{ record.ask }}
        </template>
      </a-table-column>
      <a-table-column
        v-if="tenderType === '1'"
        key="quantity"
        width="5%"
        title="数量"
        align="center"
        data-index="quantity"
      >
        <template slot-scope="text, record">
          {{ record.quantity }}
        </template>
      </a-table-column>
      <a-table-column
        v-if="tenderType === '1'"
        key="unit"
        width="5%"
        title="单位"
        data-index="unit"
        align="center"
      >
        <template slot-scope="text, record">
          {{ record.unit }}
        </template>
      </a-table-column>
      <a-table-column
        v-if="tenderType === '1'"
        key="unitPrice"
        width="10%"
        :title="'单价（'+offerTypeText+'）'"
        data-index="unitPrice"
      >
        <template slot-scope="text, record">
          <span style="color: blue">{{ record.unitPrice | NumberFormat }}</span>
        </template>
      </a-table-column>
      <a-table-column
        key="totalPrice"
        width="15%"
        :title="offerTypeText"
        data-index="unitPrice"
      >
        <template slot-scope="text, record">
          <div style="color: red">{{ record.totalPrice | NumberFormat }}</div>
        </template>
      </a-table-column>
      <a-table-column
        v-if="false"
        key="isimport"
        width="10%"
        title="是否进口"
        data-index="isimport"
      >
        <template slot-scope="text, record">
          {{ record.isimport }}
        </template>
      </a-table-column>
      <a-table-column v-if="false" key="jhq" width="10%" title="交货期" data-index="jhq">
        <template slot-scope="text, record">
          {{ record.jhq }}
        </template>
      </a-table-column>
    </a-table>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    supplierName:{
      type:String
    }
  },
  data() {
    return {
      tenderType: "",
      resultData: [],
      modalLoading: false,
      total: 0,
      offerTypeText:"总价（元）",
    };
  },
  methods: {
    initData(packId,supplierId,offerType) {
      let total = 0;
      let that = this;
      that.offerTypeText = offerType==='2'?'折扣率（%）':offerType==='3'?'下浮率（%）':that.offerTypeText;
      this.$http
        .get("/api/1/result/get_subject_detail.json?packsId=" + packId+"&supplierId="+supplierId)
        .then(function (res) {
          that.resultData = res.result;
          that.tenderType = res.tenderType;
          res.result.forEach((item) => {
            total += item.totalPrice;
          });
          that.total = total;
        });
    },
  },
};
</script>

<style scoped>
.table_two {
  width: 100%;
  border-left: 1px solid #e8e8e8;
}
.table_two td {
  padding: 10px 16px !important;
  border-bottom: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}
.w-1 {
  width: 87%;
}
.w-2 {
  width: 81.3%;
}
.w-3 {
  width: 94%;
}
.w-4 {
  width: 93.8%;
}
.hj {
  display: flex;
  justify-content: flex-end;
  font-size: 16px;
  font-weight: bold;
}
/deep/ .table .ant-table-tbody > tr > td,
/deep/ .table .ant-table-thead > tr > th {
  padding: 10px 16px !important;
}
.display {
  display: flex;
  align-items: center;
}
</style>
